export function sortStatusEntries(entries) {
  const order = {
    'in-voorbereiding': 1,
    'te-koop': 2,
    'in-optie': 3,
    verkocht: 4,
  };

  return entries
    .map((entry) => [entry, order[entry[0]] || 999])
    .sort((a, b) => a[1] - b[1])
    .map(([entry]) => entry);
}
